// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".semantic-ui .ui .huge.message.error-page {\n  text-align: center;\n  margin-right: -2%;\n  margin-left: -2%;\n}\n", ""]);
// Exports
module.exports = exports;
